module.exports = "https://codepen.io/adamgruber/pen/zEzPRm/\n\n- CodePen\n\n- set up with React and Babel\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/01_intro/notes_2.md
// module id = 1445
// module chunks = 0